<template>
  <div class="card" v-if="selectablepackages && selectablepackages.length > 0">
    <div class="card-header row-spacing">
        <button v-allowed:view="['STAFF']" class="btn btn-info" @click="openNewAdditionalModal()">Add Additional Billing</button>
    </div>
      <div class="table-responsive table-bordered">
      <table class="table pricing-table">
        <thead>
          <tr class="text-nowrap">
            <th class="table-font-size pricing-column-description">Additional Billing</th>
            <th class="table-font-size pricing-column-price">Period</th>
            <th class="table-font-size pricing-column-price">Price (Excl. VAT)</th>            
            <th v-allowed:view="['STAFF']" class="table-font-size pricing-column-price"></th>
          </tr>
        </thead>
        <tbody v-if="billingitems.length > 0">
          <tr v-for="billingitem in billingitems" :key="billingitem.additionalBillingComponentNumber">
            <td>{{ billingitem.additionalBillingPackage.additionalBilling }} {{ billingitem.additionalBillingPackage.label }}</td>
            <td> {{ prettifyBillingPeriod(billingitem.billingPeriod) }}</td>
            <td class="wd-md"> R {{ decimalFormat(billingitem.additionalBillingPackage.priceExclVat) }}</td>
            <td v-allowed:view="['STAFF']">
              <div class="text-center">
                <button class="btn btn-primary" @click="deleteAdditionalItem(billingitem) "><i class="fa fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
              <td colspan="4">No Additional Billing added to this Service</td>
          </tr>
        </tbody>
      </table>
      </div>
    <AddAdditionalBillingModal 
      ref="openNewAdditionalModal"
      :modalTitle="modalTitle"
      :additionalBillingPackages="selectablepackages"
      :availableperiods="availableperiods"
      @addAdditionalItem="addAdditional"
    />
  </div>
  <div v-else>
    <span>Product's Additional Billing needs to be configured.</span>
  </div>
</template>

<script>
import AddAdditionalBillingModal from '@/components/Admin/Modals/AddAdditionalBillingModal';
export default {
  components: {
    AddAdditionalBillingModal,
  },
  props: {
    billingitems: {
      type: Array,
      required: true
    },
    selectablepackages: {
      type: Array,
      required: true
    },
    saleDefinition: {
      type: Object,
      required: true
    },
    emptyBillingComponent: {
      type: Object,
      required: true
    },
    availableperiods: {
      type: Array,
      required: true
    }
  },
  emits: ['reloadSale'],
  data() {
    return {
      modalTitle: "",
      billingComponent: {}
    }
  },
  methods: {
    openNewAdditionalModal: function() {
      this.$refs.openNewAdditionalModal.open();
      this.modalTitle = 'Add Additional Billing Item';
    },
    addAdditional: function(data) {
      const hostUrl = this.$config.aimsAPI;
      const saleNumber = this.saleDefinition.sale.saleNumber;
      this.billingComponent = this.deepCopyObject(this.emptyBillingComponent);
      this.billingComponent.additionalBillingPackageNumber = data.additionalBillingPackageNumber;
      this.billingComponent.billingPeriod = data.billingPeriod;
      this.$http.post(`${hostUrl}sales/definition/${saleNumber}/obj/create`, this.billingComponent).then(
        () => {    
          this.showSuccess("Additional Billing Item successfully created");
          this.$emit('reloadSale');     
        },
        (error) => {
            console.error(error);
            this.showError("Error Adding Additional Billing Item", error);
        }
      );
    },
    deleteAdditionalItem: function(addition) {
      this.$swal({
                title: "Are you sure you want to delete this Billing Item?",
                text: `${addition.additionalBillingPackage.additionalBilling}`, //check name
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                  const hostUrl = this.$config.aimsAPI;
                  const saleNumber = this.saleDefinition.sale.saleNumber;
                  
                  this.$http.post(`${hostUrl}sales/definition/${saleNumber}/obj/delete`, addition).then(
                      () => {
                          this.showSuccess("Additional Billing successfully removed");
                          this.$emit('reloadSale');  
                      },
                      (error) => {
                          console.error(error);
                          this.showError("Error Deleting Billing Item", error);
                      });
                }
            });             
      },
    },
    // getLabel(period) {
    //   return this.prettifyBillingPeriod(period);
    // },

}
</script>
